import "./date-picker.scss";
import { useState, useEffect, useContext } from "react";
import Form from "react-bootstrap/Form";

import { roleRead } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";

export interface IDatePickerProps {
  label?: string;
  onChange(newValue: string, key?: string): void;
  data?: string;
  required?: boolean;
  disabled?: boolean;
}

const Datepicker = ({ label, required, data, onChange, disabled }: IDatePickerProps) => {
  const [date, setDate] = useState<string>("");
  const [readOnlyState, setReadOnlyState] = useState(false);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.length <= 1 && rolesArray.indexOf(roleRead) !== -1){
      setReadOnlyState(true);
    } else {
      setReadOnlyState(false);
    }
  }, [authCtx.selectedTenant.roles]);

  useEffect(() => {
    if (data) {
      setDate(data);
    }
  }, [data]);

  return (
    <div className="datepicker">
      <span>
        <Form.Label>
          {label}
          {required && <span className="datepicker-requiredMark">*</span>}
        </Form.Label>
      </span>
      <Form.Group>
        <Form.Control
          disabled={readOnlyState || disabled}
          type={"datetime-local"}
          name="date"
          value={date}
          required={required}
          className="datepicker-input"
          onChange={(e) => {
            setDate(e.target.value);
            onChange(e.target.value);
          }}
        />
      </Form.Group>
    </div>
  );
};

export default Datepicker;
